import { Plugin } from 'prosemirror-state';

export const InputRichTextCtrlClickPlugin = new Plugin({
  props: {
    handleClick: (_view, _pos, event) => event.ctrlKey || event.metaKey,
  },
});
